<div class="userNoAccess" *ngIf="!hasAnyPermission">
    <div class="userNoAccess-left">
        <i class="fa fa-user-lock"></i>
        <h1 class="userNoAccess-left-title">This account does <br>not have access to <br> CMA Web modules</h1>
        <h2 class="userNoAccess-left-subTitle">Please contact your supervisor.</h2>
    </div>
    <div class="userNoAccess-right">
        <img src="assets/modules-mosaic.png">
    </div>
</div>

<app-page-heading [key]="'home.page-title'" *ngIf="hasAnyPermission"></app-page-heading>

<!-- <div class="home-container" *ngIf="!powerBiReportId">
    <div class="home">
        <h1 class="home-message" [i18n]="[{target: 'innerHTML', key: 'home.message'}]"></h1>
        <div class="home-icons">
            <i class="fa fa-building i-building"></i>
            <i class="fa fa-plus i-plus"></i>
            <img class="cma-image" src="/assets/cma.png">
        </div>
    </div>
</div> -->

<div class="dashboardGrid flex-1" *ngIf="hasAnyPermission">
    <app-callout [i18nkey]="'landing-page.callout-label'"
                 [style]="'LIGHTBLUE'"></app-callout>
    <div class="flex-row flex-1">
        <div class="flex-row flex-shrink">
            <div class="flex-column">
                <div class="flex-row">
                    <div class="flex-auto">
                        <ng-container *ngIf="!canSeeCarrierPodValidationWidget && !canSeeChepPodValidationWidget"
                                      [ngTemplateOutlet]="shadow">
                        </ng-container>
                        <app-widget-pod-carrier-manager *ngIf="canSeeCarrierPodValidationWidget"></app-widget-pod-carrier-manager>
                        <app-widget-pod-chep-manager *ngIf="canSeeChepPodValidationWidget"></app-widget-pod-chep-manager>
                    </div>
                    <div class="flex-column">
                        <div class="flex-auto">
                            <app-widget-button
                                *ngIf="canSeeCarrierLoadsManagementWidget || canSeeChepLoadsManagementWidget else shadow"
                                [buttonTitleKey]="'widgets.button.load-management.title'"
                                [buttonDescription]="'widgets.button.load-management.description'"
                                [iconButton]="'fa fa-cubes'"
                                [navigateItem]="navigationService.loadsManagement().searchLoads()">
                            </app-widget-button>
                        </div>
                        <div class="flex-auto">
                            <app-widget-button
                                *ngIf="canSeeFindLoadWidget else shadow"
                                [buttonTitleKey]="'widgets.button.find-load.title'"
                                [buttonDescription]="'widgets.button.find-load.description'"
                                [iconButton]="'fa fa-cubes'"
                                [navigateItem]="navigationService.localLoads().find()">
                            </app-widget-button>
                        </div>
                    </div>
                    <div class="flex-auto">
                        <div class="cardWidget _shadowStyle flex-auto _skeleton _type2"></div>
                    </div>
                </div>

                <div class="flex-row">
                    <div class="flex-auto" *ngIf="canSeeCarrierOverdueWidget || canSeeChepOverdueWidget else shadow">
                        <app-widget-button
                            [buttonTitleKey]="'widgets.button.bluetracking.title'"
                            [buttonDescription]="'widgets.button.bluetracking.description'"
                            [iconButton]="'fa fa-calendar-alt'"
                            [navigateItem]="navigationService.overdue().list()">
                        </app-widget-button>
                    </div>
                    <div class="flex-auto"
                         *ngIf="canSeeCarrierLoadTrackingWidget || canSeeChepLoadTrackingWidget else shadow">
                        <app-widget-button
                            [buttonTitleKey]="'widgets.button.load-tracking.title'"
                            [buttonDescription]="'widgets.button.load-tracking.description'"
                            [iconButton]="'fa fa-map-marker'"
                            [navigateItem]="navigationService.realtimeTracking().overview()">
                        </app-widget-button>
                    </div>
                    <div class="flex-auto"
                         *ngIf="canSeeTnxWidget else shadow">
                        <app-widget-button
                            [buttonTitleKey]="'widgets.button.tnx.title'"
                            [buttonDescription]="'widgets.button.tnx.description'"
                            [iconButton]="'fa fa-file-alt'"
                            [navigateItem]="navigationService.tnxDashboard().list()">
                        </app-widget-button>
                    </div>
                </div>

                <div class="cardWidget _shadowStyle flex-auto _skeleton _type4"></div>
            </div>
            <div class="cardWidget _shadowStyle flex-auto _skeleton _type3" style="max-width: 344px"></div>
        </div>
    </div>
    <div class="flex-row flex-1 cardWidget _shadowStyle flex-auto _skeleton _type5"></div>
</div>

<ng-template #shadow class="flex-auto">
    <div class="cardWidget _shadowStyle flex-auto _skeleton _type4"> </div>
</ng-template>

<app-power-bi-report *ngIf="powerBiReportId"  [reportId]="powerBiReportId"></app-power-bi-report>
